/**
 * @file PlanOverviewGrid.js
 * @description Responsive label/value grid for the Plan Overview section.
 */

import styles from './PlanOverviewGrid.module.scss';

function isVisible(item) {
    return Boolean(item);
}

function CellLink({ item }) {
    return (
        <a
            href={item.href}
            onClick={item.onClick}
            className={styles.link}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={item.ariaLabel}
        >
            {item.value}
        </a>
    );
}

function CellButton({ item }) {
    return (
        <button
            type="button"
            onClick={item.onClick}
            className={`btn btn-link p-0 align-baseline text-decoration-none ${styles.link}`}
            aria-label={item.ariaLabel}
        >
            {item.value}
        </button>
    );
}

function CellBody({ item }) {
    if (item.kind === 'link' && item.href) {
        return <CellLink item={item} />;
    }
    if (item.kind === 'button' && item.onClick) {
        return <CellButton item={item} />;
    }
    return <span>{item.value}</span>;
}

function Cell({ item }) {
    return (
        <div className={styles.item}>
            <span className={styles.label}>{item.label}</span>
            <span className={styles.value}>
                <CellBody item={item} />
            </span>
        </div>
    );
}

export default function PlanOverviewGrid({ items }) {
    const visible = items.filter(isVisible);
    if (visible.length === 0) {
        return null;
    }
    return (
        <div className={styles.container}>
            {visible.map(function renderCell(item, idx) {
                return <Cell key={`${item.label}-${idx}`} item={item} />;
            })}
        </div>
    );
}
